document.addEventListener("DOMContentLoaded", () => {
    const tabButtons = document.querySelectorAll(".reviews-layout-tabs .section-green-button");
    const categoryItems = document.querySelectorAll("[data-category-id]");

    // Track which sliders have been initialized
    const initializedSliders = new Set();

    // Define default dropdown selections for each tab
    const defaultDropdownSelections = {
        'scalp-care': 'Overnight Scalp Elixir',
        'face-care': 'Energizing Day Serum',
        'wellness': 'Sleep Recovery Supplement'
    };

    function updateDropdownForTab(tabId) {
        const dropdown = document.querySelector('.custom-dropdown');
        if (!dropdown) return;

        const dropdownSelected = dropdown.querySelector('#dropdownSelected .selected-text');
        const dropdownOptions = dropdown.querySelectorAll('.dropdown-option');

        if (!dropdownSelected || !dropdownOptions.length) return;

        // Get the default selection for this tab
        const defaultSelection = defaultDropdownSelections[tabId];

        if (defaultSelection) {
            // Find the matching option and update the dropdown
            dropdownOptions.forEach(option => {
                const isMatch = option.textContent.trim() === defaultSelection;

                if (isMatch) {
                    // Update selected text
                    dropdownSelected.textContent = defaultSelection;

                    // Remove selected state from all options first
                    dropdownOptions.forEach(opt => {
                        opt.removeAttribute('data-selected');
                    });

                    // Set new selection
                    option.setAttribute('data-selected', 'true');

                    // Trigger the manual section toggle using data-value
                    const categoryId = option.getAttribute('data-value');
                    if (categoryId) {
                        // Call the dropdown's own section toggle function
                        triggerDropdownSectionToggle(categoryId);
                    }
                }
            });
        }
    }

    function triggerDropdownSectionToggle(categoryId) {
        // Hide all review sections
        const allSections = document.querySelectorAll('.reviews-carousel[data-category-id]');
        for (let i = 0; i < allSections.length; i++) {
            const sectionWrapper = allSections[i].closest('.shopify-section');
            if (sectionWrapper) {
                sectionWrapper.setAttribute('data-dropdown-controlled', 'true');
                sectionWrapper.style.display = 'none';
            }
        }

        // Show the matching section
        const matchingSection = document.querySelector('.reviews-carousel[data-category-id="' + categoryId + '"]');
        if (matchingSection) {
            const sectionWrapper = matchingSection.closest('.shopify-section');
            if (sectionWrapper) {
                sectionWrapper.setAttribute('data-dropdown-controlled', 'true');
                sectionWrapper.style.display = 'block';
            }
        }

        // Re-initialize carousel if jQuery and slick are available
        if (typeof $ !== 'undefined' && $.fn.slick) {
            const $carousel = $('.carousel-container');
            if ($carousel.length && $carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
            if ($carousel.length) {
                $carousel.slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    centerMode: false,
                    customPaging: function (slider, index) {
                        return '<button type="button" class="slick-dot">' + (index + 1) + '</button>';
                    },
                    prevArrow:
                        '<button type="button" class="slick-prev" aria-disabled="true" aria-label="Previous slide"><svg width="20" height="20" viewBox="0 0 48 48"><path d="M0 0h48v48H0z" fill="none"/><g><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
                    nextArrow:
                        '<button type="button" class="slick-next" aria-disabled="false" aria-label="Next slide"><svg width="20" height="20" viewBox="0 0 48 48"><path d="M0 0h48v48H0z" fill="none"/><g><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
                });
            }
        }
    }

    function showSectionsMatchingTab(tabId) {
        // First, hide all sections
        categoryItems.forEach((item) => {
            const sectionWrapper = item.closest(".shopify-section");
            if (sectionWrapper && !sectionWrapper.hasAttribute('data-dropdown-controlled')) {
                // Don't hide reviews carousel sections - check by class
                const isReviewsCarousel = sectionWrapper.querySelector('.flex-reverse') ||
                    sectionWrapper.classList.contains('flex-reverse');

                if (!isReviewsCarousel) {
                    sectionWrapper.style.display = "none";
                }
            }
        });

        // Then show only the matching sections
        const visibleItems = document.querySelectorAll(`[data-category-id="${tabId}"]`);
        visibleItems.forEach((item) => {
            const sectionWrapper = item.closest(".shopify-section");
            if (sectionWrapper) {
                sectionWrapper.style.display = "block";
            }
        });

        // Update dropdown selection for the current tab (with a small delay to ensure DOM is ready)
        setTimeout(() => {
            updateDropdownForTab(tabId);
        }, 150);

        // Wait for display changes to take effect
        setTimeout(() => {
            // Handle slick sliders in visible sections
            const visibleSliders = document.querySelectorAll(`[data-category-id="${tabId}"] .slick-slider-init`);

            visibleSliders.forEach(slider => {
                const sliderId = slider.id || `slider-${Math.random().toString(36).substr(2, 9)}`;
                if (!slider.id) slider.id = sliderId;

                // Check if the slider is initialized using jQuery's slick method
                const isInitialized = $(slider).hasClass('slick-initialized');

                if (isInitialized) {
                    // If slider is already initialized, refresh it
                    try {
                        // First unslick to prevent potential issues
                        $(slider).slick('unslick');
                        // Re-initialize with the original settings
                        initializeSliderWithOriginalSettings(slider);
                        initializedSliders.add(sliderId);
                    } catch (e) {
                        console.warn("Error refreshing slider:", e);
                    }
                } else {
                    // Initialize the slider if it's not already initialized
                    try {
                        initializeSliderWithOriginalSettings(slider);
                        initializedSliders.add(sliderId);
                    } catch (e) {
                        console.warn("Could not initialize slider:", e);
                    }
                }
            });

            // Also look for twentytwenty containers and initialize them if needed
            const twentyTwentyContainers = document.querySelectorAll(`[data-category-id="${tabId}"] .twentytwenty-container`);
            if (twentyTwentyContainers.length > 0 && typeof $.fn.twentytwenty === 'function') {
                twentyTwentyContainers.forEach(container => {
                    try {
                        $(container).twentytwenty({
                            default_offset_pct: 0.5,
                            orientation: 'horizontal',
                            before_label: 'Before',
                            after_label: 'After',
                            no_overlay: true,
                        });
                    } catch (e) {
                        console.warn("Could not initialize twentytwenty:", e);
                    }
                });
            }
        }, 100);
    }

    // Function to initialize a slider with its original settings
    function initializeSliderWithOriginalSettings(slider) {
        // Check for specific slider types and apply appropriate settings
        if ($(slider).closest('.collection-product-list').length) {
            console.log("called.....");
            // This is a PDP featured collection slider
            // Get the actual slide elements rather than all children
            const slideCount = $(slider).find('.collection-product-card').length || $(slider).children().length;
            const windowWidth = $(window).width();

            // Always initialize slick on mobile, or on desktop if more than 4 slides
            if (windowWidth <= 992 || slideCount > 4) {

                $(slider).removeClass('desktop-grid');

                const settings = {
                    infinite: false,
                    slidesToScroll: 1,
                    autoplay: false,
                    dots: false,
                    centerMode: false,
                    arrows: windowWidth > 992, // Only show arrows on desktop
                    responsive: [
                        {
                            breakpoint: 9999, // This will apply to desktop
                            settings: {
                                slidesToShow: slideCount > 4 ? 4.05 : slideCount,
                                arrows: true,
                                prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
                                nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>'
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2.2,
                                centerMode: false,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1.2,
                                centerMode: false,
                                arrows: false,
                            }
                        }
                    ]
                };

                $(slider).slick(settings);
            } else {
                // Make sure it's not initialized
                if ($(slider).hasClass('slick-initialized')) {
                    $(slider).slick('unslick');
                }

                // Apply any necessary desktop non-carousel styles
                $(slider).addClass('desktop-grid');
            }
            return;
        } 
        if ($(slider).closest('.compare-slide-container').length) {
            // This is a compare slider
            $(slider).slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                arrows: true,
                dots: true,
                centerMode: false,
                swipeToSlide: true,
                draggable: false,
                swipe: false,
                prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
                customPaging: function (slider, i) {
                    const imageBefore = slider.$slides.eq(i).find('img').first().data('src');
                    return `<button type="button"><img src="${imageBefore}" alt="Dot image" class="dot-image"/></button>`;
                },
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        } else if ($(slider).closest('.doctor-quote-slider').length || $(slider).hasClass('doctor-quote-slider-wrapper')) {
            // This is a doctor quote slider
            $(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                centerPadding: "10px",
                infinite: false,
                arrows: true,
                accessibility: false,
                prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        } else {
            // Default initialization for other sliders
            $(slider).slick();
        }
    }

    // Function to handle window resize events
    function handleResize() {
        const activeTabId = document.querySelector('.reviews-layout-tabs .section-green-button.active')?.getAttribute('data-tab-id');
        if (activeTabId) {
            showSectionsMatchingTab(activeTabId);
        }
    }

    // Add resize event listener with debounce
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 250);
    });

    // Initialize the first tab
    if (tabButtons.length > 0) {
        const initialTabId = tabButtons[0].getAttribute("data-tab-id");
        tabButtons[0].classList.add("active");
        showSectionsMatchingTab(initialTabId);
    }

    // Set up tab click events
    tabButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const selectedTabId = button.getAttribute("data-tab-id");

            // Update active tab styling
            tabButtons.forEach((btn) => btn.classList.remove("active"));
            button.classList.add("active");

            // Show appropriate sections and handle sliders
            showSectionsMatchingTab(selectedTabId);
        });
    });
});








